import type { RedlineEdit } from '../../../../redlines/redline-shapes';
import type { MakeSuggestionSource } from '../../../types';
import type { EditOutputWithSource } from '../types';

/**
 * Converts an EditOutput to EditOutputWithSource by attaching each action's
 * groupId and the SuggestionSource built by the caller's `makeSource` factory
 * (undefined when the factory declines to stamp — a user-attributed
 * materialization).
 *
 * GroupIds are always generated on the server and must be passed in via the
 * `groupIds` array (one per action, in order). The absence of a groupId
 * indicates a bug in the upstream pipeline.
 */
export function addSourceToEditOutput(
  editOutput: RedlineEdit,
  { groupIds, makeSource }: { groupIds: string[]; makeSource: MakeSuggestionSource }
): EditOutputWithSource {
  const actionsWithSource = editOutput.edit.actions.map((action, index) => {
    const groupId = groupIds[index];
    if (!groupId) {
      throw new Error(`Missing groupId for action at index ${index}`);
    }

    return {
      ...action,
      groupId,
      source: makeSource(groupId),
    };
  });

  return {
    edit: {
      ...editOutput.edit,
      actions: actionsWithSource,
    },
  };
}
